export const SEND_CONTACT = 'sendContact';
export const SENT_CONTACT = 'sentContact';
export const CONTACT_US = 'contactUs';
